import style from './SummaryPageView.css';
import SenderReceiverBlock from '../SenderReceiverBlock/SenderReceiverBlock';
import ListItem from '../../shared/List/ListItem';
import useTranslation from '../../../localization/i18n.context';
import List from '../../shared/List/List';
import Alert from '../../shared/Alert/Alert';
import { SummaryPageViewProvider } from './SummaryPageViewProvider';
import { EnterAmountType } from '../../../routes/EnterAmountPage/EnterAmountProvider';
import { renderIf } from '../../../utils/render.utils';
import styles from '../../../routes/OutlineOnboarding/OutlineOnboardingPage.css';
import { SenderReceiverProvider } from '../SenderReceiverBlock/SenderReceiverProvider';

export default function SummaryPageView({
                                          className = '',
                                          params,
                                          type,
                                          amount,
                                          reasonDescription,
                                        }) {
  const { t, getCurrency, getOrganization } = useTranslation();
  const data = SummaryPageViewProvider(
    t,
    params,
    amount,
    getCurrency,
    type?.toUpperCase(),
    getOrganization,
  );

  function getSender(type) {
    switch (type?.toUpperCase()) {
      case EnterAmountType.P2P: {
        return params.cardFrom;
      }

      case EnterAmountType.MICROLOAN_PAYMENT: {
        return {
          organizationCode: params.sender?.organizationCode,
        };
      }

      case EnterAmountType.MICROLOAN: {
        return {
          name: t('Credit'),
        };
      }
      case EnterAmountType.POS: {
        return {
          name: t('Card'),
          balance: params.amount,
          organizationCode: params.sender?.organizationCode,
        };
      }
      case EnterAmountType.SEND_MONEY_TO_COMPANY: {
        return {
          balance: params.amount,
          organizationCode: params.sender?.organizationCode,
        };
      }
    }
  }

  function getReceiver(type, getOrganization) {
    switch (type?.toUpperCase()) {
      case EnterAmountType.P2P: {
        return params.cardTo;
      }

      case EnterAmountType.MICROLOAN: {
        return {
          name: getOrganization(params.beneficiary.organizationCode),
          organizationCode: params.beneficiary.organizationCode,
        };
      }

      case EnterAmountType.MICROLOAN_PAYMENT: {
        return {
          name: t('Credit repayment'),
        };
      }
      case EnterAmountType.POS: {
        return params.beneficiary;
      }
      case EnterAmountType.SEND_MONEY_TO_COMPANY: {
        return params.beneficiary;
      }
      default: {
        return params.receiver;
      }
    }
  }

  const sender = getSender(type);
  const receiver = getReceiver(type, getOrganization);

  const senderIcon = SenderReceiverProvider.getSenderIcon(
    type?.toUpperCase(),
    sender,
  );
  const receiverIcon = SenderReceiverProvider.getReceiverIcon(
    type?.toUpperCase(),
    receiver,
  );

  const listWithReason = data?.list ? [...data.list] : [];

  const phoneNumberIndex = listWithReason.findIndex(item =>
    item.title.toLowerCase().includes('phone') ||
    item.title.includes(t('Phone number'))
  );

  if(type?.toUpperCase() === EnterAmountType.P2P){
    if (reasonDescription && phoneNumberIndex !== -1) {
      listWithReason.splice(phoneNumberIndex + 1, 0, {
        title: t('Transfer reason'),
        subtitle: t(reasonDescription),
      });
    } else if (reasonDescription) {
      listWithReason.unshift({
        title: t('Transfer Reason'),
        subtitle: t(reasonDescription),
      });
    }
  }

  return (
    <div className={`${style.container} ${className}`}>
      <SenderReceiverBlock
        className={style.header}
        sender={sender}
        receiver={receiver}
        senderIcon={senderIcon}
        receiverIcon={receiverIcon}
      />
      {data.alert && type?.toUpperCase() === EnterAmountType.POS && (
        <Alert
          className={style.alert}
          type={data.alert.info}
          hasIcon={true}
          message={data.alert.message}
        />
      )}
      {renderIf(
        listWithReason && listWithReason.length > 0,
        <List className={styles.list}>
          {listWithReason.map((item, index) => (
            <ListItem
              key={`list-item-${index}`}
              titleClassName={style.listItemTitle}
              title={
                <div
                  className={`${style.listItem} ${style[item.titleStyleName] || ''}`}
                >
                  <span>{item.title}</span>
                  <span>{item.subtitle}</span>
                </div>
              }
            />
          ))}
        </List>,
      )}
      {data?.alert && type?.toUpperCase() !== EnterAmountType.POS && (
        <Alert
          className={style.alert}
          type={data.alert.info}
          hasIcon={true}
          message={data.alert.message}
        />
      )}
    </div>
  );
}